import { render, staticRenderFns } from "./usTaxPackageConfirmation.vue?vue&type=template&id=2f229d4b&scoped=true"
import script from "./usTaxPackageConfirmation.vue?vue&type=script&lang=js"
export * from "./usTaxPackageConfirmation.vue?vue&type=script&lang=js"
import style0 from "./usTaxPackageConfirmation.vue?vue&type=style&index=0&id=2f229d4b&prod&lang=less&scoped=true"
import style1 from "./usTaxPackageConfirmation.vue?vue&type=style&index=1&id=2f229d4b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f229d4b",
  null
  
)

export default component.exports